var projectTimeline = {
	"Project timeline": "Garis Waktu Proyek",
	"None planned": "Belum Ada Rencana",
	"1-3 months": "1-3 bulan",
	"4-6 months": "4-6 bulan",
	"7-12 months": "7-12 bulan",
	"More than 1 year": "Lebih dari 1 Tahun"
};

export { projectTimeline as default };
